import { render, staticRenderFns } from "./WidgetRemocoesStats.vue?vue&type=template&id=09f1e876&"
import script from "./WidgetRemocoesStats.vue?vue&type=script&lang=js&"
export * from "./WidgetRemocoesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports